module.exports = __webpack_public_path__ + "static/media/security-black-18dp.d4f3cc91.svg";